import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { selectCustomer, selectProject, setFilterFormExpanded } from './job-filter.actions';

export const featureKey = 'job-filter';

export interface State {
  filterFormExpanded: boolean;
  selectedCustomerId: number;
  selectedProjectId: number;
}

export interface AppState {
  [featureKey]: State;
}

export const initialState: State = {
  filterFormExpanded: false,
  selectedCustomerId: null,
  selectedProjectId: null,
};

const jobFilterReducer = createReducer(
  initialState,
  on(selectCustomer, (state, { customerId }): State => ({ ...state, selectedCustomerId: customerId })),
  on(selectProject, (state, { projectId }): State => ({ ...state, selectedProjectId: projectId })),
  on(setFilterFormExpanded, (state, { expanded }): State => ({ ...state, filterFormExpanded: expanded })),
);

export function reducer(state: State | undefined, action: Action) {
  return jobFilterReducer(state, action);
}

export const selectJobFilterState = createFeatureSelector< State>(featureKey);
export const selectSelectedCustomerId = createSelector(selectJobFilterState, (state: State) => state.selectedCustomerId);
export const selectSelectedProjectId = createSelector(selectJobFilterState, (state: State) => state.selectedProjectId);
export const selectFilterFormExpanded = createSelector(selectJobFilterState, (state: State) => state.filterFormExpanded);
